import LandingReveal from '@/modules/Pages/shared/LandingReveal';

const notThis = ['Watch more dashboards', 'Add people just to keep track of more accounts'];

export default function CapacitySection() {
  return (
    <section className="py-24 px-6 bg-dark-gray-b border-t border-light">
      <div className="max-w-6xl mx-auto grid lg:grid-cols-2 gap-14 items-center">
        <LandingReveal>
          <h2 className="landing-headline text-3xl md:text-4xl font-bold leading-tight mb-6">
            Protect more recurring revenue with the CS capacity you already have.
          </h2>
          <p className="landing-prose mb-8">
            As your customer base grows, your ability to manage churn risk should grow with it.
          </p>

          <div className="space-y-4 mb-8">
            <p className="text-sm uppercase tracking-wider text-secondary font-semibold">Not by</p>
            {notThis.map((item) => (
              <div key={item} className="flex items-start gap-3 text-secondary">
                <span className="text-pink font-bold">×</span>
                <span>{item}</span>
              </div>
            ))}
          </div>

          <p className="text-xl font-semibold text-primary font-secondary border-l-2 border-green pl-4">
            By getting better at knowing where your team needs to act.
          </p>
        </LandingReveal>

        <LandingReveal delayClass="landing-delay-1" className="landing-card p-2 overflow-hidden">
          <img
            src="/images/segments1.png"
            alt="Smart customer segments for targeted retention"
            className="w-full rounded-lg object-contain"
          />
        </LandingReveal>
      </div>
    </section>
  );
}
